/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Friends_RotateInputs */

const en_friends_rotate = /** @type {(inputs: Friends_RotateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make a new code`)
};

const de_friends_rotate = /** @type {(inputs: Friends_RotateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuen Code erzeugen`)
};

/**
* | output |
* | --- |
* | "Make a new code" |
*
* @param {Friends_RotateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const friends_rotate = /** @type {((inputs?: Friends_RotateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Friends_RotateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_friends_rotate(inputs)
	return en_friends_rotate(inputs)
});